const host = window && window.location && window.location.host
var hostname = window && window.location && window.location.hostname

export const CDN_URL = `https://${host}/`
export const API_ROOT = 'https://data.demo.bookeeapp.com'
export const INBOX_API_ROOT = 'https://inbox.demo.bookeeapp.com'

export const IMAGE_PATH = 'assets/images/'
export const CDN_PATH = CDN_URL + IMAGE_PATH
export const SEARCH_REDIRECT = ''
export const ENVIRONMENT = 'staging'
export const PROD = false
export const ADYEN_CLIENT_KEY = 'test_D5QBQNKT3FCFTKHITY2MEEWP5Q4PX5XL'
